// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"44efc66f","224":"3f544616","313":"616e8537","315":"747af78b","544":"f81ec531","811":"a886b44f","891":"5e3ba1d7","980":"0f74fc77"}[chunkId] + ".chunk.css";
};